import { Component, OnInit, inject } from '@angular/core';
import { AuthService } from "../../../services/auth/auth.service";
import { ActivatedRoute, Router } from "@angular/router";
import {AnalyticsService} from "../../../services/analytics/analytics.service";
import { firstValueFrom } from "rxjs";

@Component({
    selector: 'xplorer-bowser-load-user',
    templateUrl: './load-user.component.html',
    styleUrls: ['./load-user.component.css'],
    standalone: true
})
export class LoadUserComponent implements OnInit {

  loadingText: any;

  private readonly authService: AuthService = inject(AuthService);
  private readonly route: ActivatedRoute = inject(ActivatedRoute);
  private readonly router: Router = inject(Router);
  private readonly analyticsService: AnalyticsService = inject(AnalyticsService);


  ngOnInit(): void {
    let sourcePath = this.route.snapshot.queryParams['source'];
    this.processUserInfo(sourcePath);
  }

  processUserInfo = (sourcePath: string) => {
    const redirectUrl = sourcePath ? sourcePath : 'profile';
    this.completeKeycloakLogin(redirectUrl);
  };

  private completeKeycloakLogin = async (redirectUrl: string) => {
    try {
      await firstValueFrom(this.authService.completeKeycloakLogin());

      this.analyticsService.addLoginKeycloakAction();
      await this.router.navigate([redirectUrl]);
    } catch (error) {
      console.error('[LOAD_USER] Error while processing keycloak user info', error);
      this.authService.clearTokenStorage();
      await this.router.navigate(['login'], {
        state: { passwordFlowMessage: 'login.error.text' }
      });
    }
  }


}
